import React, { FC } from 'react'
import styled from 'styled-components'

import { modalRoutes, routes } from 'packages/route'
import { NestedRoute } from 'packages/route/components'

/**
 * 活动登录界面 layout
 *
 * @returns component
 */
export const UserLayout: FC = () => {
  return (
    <Wrapper>
      <NestedRoute
        routes={routes}
        modalRoutes={modalRoutes}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${(props) => props.theme.background._4};
  height: 100vh;
  overflow: hidden;
`
